import React, { useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import star from './QuestionStep/assets/star.png'
import cloud1 from './QuestionStep/assets/calculator.png'
import cloud2 from './QuestionStep/assets/cloud3.png'
import gifRresult from './QuestionStep/assets/10_megphone 2.gif'
import jpgResult from './QuestionStep/assets/static/10_megphone-2.jpg'
import { getLogo }  from './LocalizedPictures'
import { setNewAnswer, calculateResult, clearAllAnswer } from '../Store'
import CountUp from 'react-countup';
import './Home.css'
import { AppContext} from '../contexts/AppProvider'
import { useLocalize } from 'localize-react';



function CulcRes() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const next = () => {
        history.push(`/Q/Result`)
    }

    const { translate } = useLocalize()
    
    useEffect(() => {
     setTimeout(() => {
        next()
          }, 3000);
    })
    console.log("calculateResult 1");
    let theNumber = calculateResult();
    
    let yearsNumber = theNumber * 12;
    return (

        <div className="middle">
            <div className="up-middle culc-res">
                <img id="cloud1" className="cloud" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={cloud1} alt="" />
                <img id="cloud2" className="cloud3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={cloud2} alt="" />
                <img className="star rotate" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <img className="star2 rotate2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <img className="star3 rotate3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <img className="culcRes" src={settings.isAnimationPause ? jpgResult : gifRresult} alt="" />
            </div>
            <div className="culcHeading">
                {translate('Crunching the numbers.')}
            </div>
            <div className="culcRules">
                {translate('calculatingText1')}
                <br />
                {translate('calculatingText2')}
                <br />
                {translate('calculatingText3')}
            </div>
            <div className="up-middle culc-res">
                <img className="star7 rotate" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <img className="star rotate" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <img className="star5 rotate2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <img className="star6 rotate3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <img className="star8 rotate3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}} src={star} alt="" />
                <div className="reslogo culc-res">
                    <img width="150" src={getLogo()} alt="" />
                </div>
            </div>
        </div>


    )
}

export default CulcRes
